import { render, staticRenderFns } from "./slots-filter.vue?vue&type=template&id=34525680"
import script from "./slots-filter.vue?vue&type=script&lang=js"
export * from "./slots-filter.vue?vue&type=script&lang=js"
import style0 from "./slots-filter.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/common/slots-filter/slots-filter.vue
// module id = qnft
// module chunks = 0